import clone from 'lodash/cloneDeep';
import initialState from '../../../store/initialState';
import {
  ADD_MEMBER_STARTING,
  ADD_MEMBER_SUCCESS,
  ADD_MEMBER_ERROR,
} from '../../../constants/actionTypes';

export default function addTenantReducer(state = initialState.addMember, action) {
  switch (action.type) {
    case ADD_MEMBER_STARTING: {
      const newState = clone(state);
      newState.saving = true;
      newState.saved = false;
      return newState;
    }

    case ADD_MEMBER_SUCCESS: {
      const { data } = action;

      const newState = clone(state);
      newState.saving = false;
      newState.saved = true;
      newState.error = null;

      newState.newMember = data.member;
      return newState;
    }

    case ADD_MEMBER_ERROR: {
      const newState = clone(state);
      newState.saving = false;
      newState.saved = false;
      newState.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
